// eslint-disable-next-line
export const _get = (object: any, keys: string | string[], defaultVal: any = '') => {
  keys = Array.isArray(keys) ? keys : keys.split('.');
  object = object[keys[0]];
  if (object && keys.length > 1) {
    return _get(object, keys.slice(1), defaultVal);
  }
  return object === undefined ? defaultVal : object;
};
